module.exports = __webpack_public_path__ + "files/3b4785dd2259858f01db7b4664cb3ce5.png";